import './input.styles.scss';

const Input = ({ title, handleChange, handleSubmit }) => {
  return (
    <div className='input-container'>
      <input
        value={title}
        required
        onChange={handleChange}
        placeholder='Add a task...'
        type='text'
      />
      <button onClick={handleSubmit}>Add Task</button>
    </div>
  );
};

export default Input;
